export const CONTACT = {
  PHONE: '800-840-4733',
  REQUEST_RETURN_PHONE: '800-840-4733',
  EMAIL: 'customerservice@brainstormlogistics.com',
};
